(() => {
    Metro.i18n.add("uk", {
        weekStart: 1,

        january: "Січень",
        february: "Лютий",
        march: "Березень",
        april: "Квітень",
        may: "Травень",
        june: "Червень",
        july: "Липень",
        august: "Серпень",
        september: "Вересень",
        october: "Жовтень",
        november: "Листопад",
        december: "Грудень",

        january_short: "Січ",
        february_short: "Лют",
        march_short: "Бер",
        april_short: "Кві",
        may_short: "Тра",
        june_short: "Чер",
        july_short: "Лип",
        august_short: "Сер",
        september_short: "Вер",
        october_short: "Жов",
        november_short: "Лис",
        december_short: "Гру",

        sunday: "Неділя",
        monday: "Понеділок",
        tuesday: "Вівторок",
        wednesday: "Середа",
        thursday: "Четвер",
        friday: "П'ятниця",
        saturday: "Субота",

        sunday_short: "Нед",
        monday_short: "Пон",
        tuesday_short: "Вів",
        wednesday_short: "Сер",
        thursday_short: "Чет",
        friday_short: "Птн",
        saturday_short: "Суб",

        sunday_short_2: "Нд",
        monday_short_2: "Пн",
        tuesday_short_2: "Вт",
        wednesday_short_2: "Ср",
        thursday_short_2: "Чт",
        friday_short_2: "Пт",
        saturday_short_2: "Сб",

        label_ok: "OK",
        label_cancel: "Відміна",
        label_done: "Виконано",
        label_today: "Сьогодні",
        label_now: "Зараз",
        label_clear: "Очистити",
        label_help: "Допомога",
        label_yes: "Так",
        label_no: "Ні",
        label_random: "Випадково",
        label_save: "Зберігти",
        label_reset: "Скинути",
        label_submit: "Відправити",
        label_add_user_color: "Додати до зразків",
        label_send: "Відправити",
        label_accept: "Прийняти",
        label_cookies_title: "Цей сайт використовує файли cookie",
        label_cookies_text:
            "Цей веб-сайт використовує файли cookie, щоб забезпечити вам найкращий досвід використання нашого веб-сайту.",
        label_choose_file: "Виберіть файл(и)",
        label_drop_file: "Натисніть або перетягніть файл(и) сюди",
        label_files_selected: "Вибрано {n} файл(ів)",

        label_days: "дні",
        label_hours: "год",
        label_minutes: "хвил",
        label_seconds: "сек",
        label_month: "міс",
        label_months: "місяці",
        label_day: "день",
        label_year: "рік",
        label_years: "років",

        label_rows_count: "Показати:",
        label_search: "Пошук:",
        label_table_info: "Відображено з $1 по $2 із $3 записів",
        label_prev: "Попередній",
        label_next: "Наступний",
        label_all: "Усі",
        label_inspector: "Інспектор",
        label_goto_page: "Перейти",
        label_enter_page: "Введіть сторінку...",
        label_empty: "Нічого показати",
        label_user_colors: "Кольори користувача",
        label_tiles: "Плитка",
        label_list: "Список",
        label_load_more: "Показати ще",
        label_buy: "Купити",
        label_buy_now: "Купити зараз",
        label_buy_today: "Купити сьогодні",
        label_download: "Завантажити",
        label_search_results: "Результати пошуку",
        label_add: "Додати",
        label_edit: "Редагувати",
        label_delete: "Видалити",
        label_new: "Нове",
        label_sell: "Продати",
        label_details: "Подробиці",
        label_sorting: "Сортування",
        label_finish: "Завершити",
        label_play: "Відтворити",
        label_pause: "Пауза",
        label_stop: "Зупинити",
        label_mute: "Без звуку",
        label_loop: "Повторювати",

        label_on: "увм",
        label_off: "вим",

        label_rename_tab: "Перейменувати вкладку",
        label_close_tab: "Закрити вкладку",
        label_close_other_tabs: "Закрити інші вкладки",
        label_close_tabs_left: "Закрити вкладки ліворуч",
        label_close_tabs_right: "Закрити вкладки праворуч",
        label_close_all_tabs: "Закрийте всі вкладки",
        label_close_inactive_tabs: "Закрити неактивні вкладки",

        label_clear_input: "Очистити введення",
        label_reveal_password: "Відкрити пароль",
        label_hide_password: "Приховати пароль",
        label_generate_random: "Генерувати випадковe значення",
        label_search_input: "Шукати введене значення",

        label_note: "Примітка",
        label_tip: "Підказка",
        label_info: "Інформація",
        label_warning: "Увага",
        label_question: "Питання",
        label_error: "Помилка",
        label_success: "Успіх",
        label_caution: "Обережно",
        label_alert: "Попередження",
        label_bug: "Помилка",
        label_fuck: "Бля",
        label_important: "Важливо",
        label_shit: "От лайно",
        label_air: "Пуффф...",

        label_select_all: "Вибрати усі",
        label_select_more: "Виберіть...",
        label_select: "Вибрати",
        label_filter: "Фільтр",

        label_collapse: "Згорнути",
        label_attach: "Прикріпити",
    });
})();
